/*@ngInject*/
const DataSetReferencesController = function ($rootScope, $scope, $state, options, configurationMediator, localization, coreConstant, navigationStateModel) {

    localization.getTranslationsByKeys([this.translationsKey, 'dataSetReferences']).then(function (translations) {

            $scope.viewModel = {
                title: translations.title,
                okButton: options.deleteDataSet || options.modifyDataSet ? translations.yesButton : translations.okButton,
                cancelButton: options.deleteDataSet || options.modifyDataSet ? translations.cancelButton : '',
                dataSetReferenceList: null,
                dataSetParams: {
                    key: 'name',
                    sortType: 'asc'
                }
            };

        $scope.getType = function (type) {
            return _.get(translations, 'type.' + type);
        };

        $scope.onSort = function (event, params) {
            $scope.viewModel.dataSetParams = params;
            $scope.viewModel.dataSetReferenceList = _.orderBy($scope.viewModel.dataSetReferenceList, [params.key], [params.sortType]);
        };

        $scope.onConfirm = function () {
            $scope.$close({dataSetName: options.dataSetName});
        };

        $scope.onCancel = function () {
            $scope.$dismiss();
        };

            $scope.init = function () {
                configurationMediator.getDataSetReferences(options.dataSetName).then(function (result) {
                    $scope.viewModel.dataSetReferenceList = _.orderBy(result, [$scope.viewModel.dataSetParams.key], [$scope.viewModel.dataSetParams.sortType]);
                    if (options.deleteDataSet) {
                        $scope.viewModel.dataSetReferencesMessage = _.replace(translations['dataSetReferencesFoundForDelete'], '{0}', result.length);
                    } else if (options.modifyDataSet) {
                        $scope.viewModel.dataSetReferencesMessage = _.replace(translations['dataSetReferencesFoundForModify'], '{0}', result.length);
                    } else {
                        $scope.viewModel.dataSetReferencesMessage = _.replace(translations['dataSetReferencesFound'], '{0}', result.length);
                    }
                    $scope.viewModel.dataSetReferencesMessage = _.replace($scope.viewModel.dataSetReferencesMessage, '{1}', '<b>' + options.dataSetName + '</b>');
                });
            };

        $scope.init();
    });

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('ums.configuration')
    .controller('dataSetReferencesController', DataSetReferencesController);
